export default [
  // { name: '跨區外送', size: 'large' },
  // { name: '盆菜專區', size: 'small', link: '/cny2021' },
  { name: '點單精選', size: 'large' },
  { name: '抵食優惠', size: 'small' },
  { name: '人氣餐廳', size: 'small' },
]
